<script setup>
import { IonItem, IonCheckbox, IonLabel, modalController } from "@ionic/vue";
import InfoModal from "@lib/components/InfoModal";
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  routing: {
    type: String,
    required: true,
  },
});

const personalDataPrivacyLabel = computed(() => {
  let result = "";
  if (props.routing === "BetterDoc") {
    result =
      "Ich willige ein, meine personenbezogenen Daten zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern dem medizinischen Fachpersonal von BetterDoc bereitzustellen und ";
  } else if (props.routing.startsWith("ARAG Case Management")) {
    result =
      "Ich willige ein, meine personenbezogenen Daten zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern den ARAG Gesundheitsassistenten bereitzustellen und ";
  } else if (props.routing === "Quality Smile") {
    result =
      "Ich willige ein, meine personenbezogenen Daten zum Zweck der Unterstützung für mein gesundheitliches Anliegen und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern dem Patientenservice von Quality Smile bereitzustellen und ";
  }
  result +=
    " dass meine personenbezogenen Daten von dieser ausschließlich zu diesem Zweck verarbeitet und genutzt werden und nehme die ";
  return result;
});

const personalDataPrivacyText = computed(() => {
  let result =
    "<p>Bei Ihren personenbezogenen Daten handelt es sich um Anrede, Vorname, Nachname, Alter, Anschrift, Telefonnummer sowie E-Mail-Adresse und die Versicherungsnummer Ihrer ARAG-Krankenversicherung. Ferner werden Arzt-/Klinikvorschläge sowie bei Vereinbarung eines Termins die Daten von behandelnden Gesundheitsdienstleistern (Vorname, Nachname, Fachrichtung, Anschrift), Zeitpunkt und Ort des Termins von der ";
  if (props.routing === "BetterDoc") {
    result += "BetterDoc GmbH ";
  } else if (props.routing.startsWith("ARAG Case Management")) {
    result += "ARAG Krankenversicherungs-AG ";
  } else if (props.routing === "Quality Smile") {
    result += "Quality Smile GmbH ";
  }
  result +=
    "an Roodie übermittelt, um diese Informationen in Ihrem Konto in der Roodie ARAG App zu speichern.</p>";

  if (props.routing === "BetterDoc") {
    result +=
      "<p>Bitte beachten Sie, dass bei Weiterleitung an die BetterDoc GmbH bekannt wird, dass für Sie eine Krankenversicherung bei der ARAG-Krankenversicherung besteht.</p>";
  } else if (props.routing === "Quality Smile") {
    result +=
      "<p>Bitte beachten Sie, dass bei Weiterleitung an die Quality Smile GmbH bekannt wird, dass für Sie eine Krankenversicherung bei der ARAG-Krankenversicherung besteht.</p>";
  }
  return result;
});

const openInfoModal = async (text) => {
  const modal = await modalController.create({
    component: InfoModal,
    cssClass: "my-custom-class",
    componentProps: {
      title: "",
      text: text,
    },
  });
  return modal.present();
};
</script>

<template>
  <ion-item lines="none" class="ion-margin-top">
    <ion-checkbox
      slot="start"
      :value="modelValue"
      @ionChange="$emit('update:modelValue', $event.detail.checked)">
    </ion-checkbox>
    <ion-label class="ion-text-wrap" color="primary">
      {{ personalDataPrivacyLabel }}
      <u class="u-bold"
        ><a
          href="#"
          @click.prevent="
            $browser.open({
              url: 'https://www.roodie-health.com/arag/datenschutz',
            })
          "
          >Datenschutzinformationen</a
        ></u
      >
      zur Kenntnis. Diese Einwilligung kann von mir jederzeit widerrufen werden.
      <a
        href="#"
        @click.prevent="openInfoModal(personalDataPrivacyText)"
        style="text-decoration: none"
        >MEHR</a
      >
    </ion-label>
  </ion-item>
</template>
